import React from "react";
import {component_tool, utils_tool} from '@/tool';
import {WizTableForm} from '@/containers/common';
import moment from "moment";
import '@/styles/containers/train/credit/subjectcreditrecord/index.less'

let {$$, checkStrLength} = utils_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
};
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

let {WizDataTable, WizButton} = component_tool

export const coursewareDetailColumns = (self, employees, other) => {
  let columns = [
    {
      title: '章节名称',
      dataIndex: 'name',
      key: 'name',
      width: 250,
      ellipsis: true,
      render: text => <a>{text}</a>,
    },
    {
      title: '顺序',
      dataIndex: 'itemOrder',
      key: 'itemOrder',
      width: 80,
      render: text => <a>{text}</a>,
    },
    {
      title: '最新同步时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
      render: (text, record) => (
        <>{record && record.updateTime ? formatterDate(record.updateTime) : ''}</>
      ),
    },
  ];
  return columns;
}

